import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
    CLASS_PATH,
    GROUP_PATH,
    STUDENT_PATH,
    YEAR_GROUP_PATH,
    TEACHER_PATH
} from '../../helpers/constants';

/**
 * Generates the react router <Route> components for each report level (all classes, single class, etc.)
 * and the <Redirect> component to go to default path if route does not fully match any report level
 * These are child routes for a report type (activity mastery, etc.) - this component is used in
 * a report type's base container component
 * Handles generating the different routes for admins vs teachers
 */

export class ReportRoutes extends Component {
    static propTypes = {
        isAdmin: PropTypes.bool,
        match: PropTypes.shape({
            url: PropTypes.string
        }),
        children: PropTypes.node,
        components: PropTypes.shape({
            allClasses: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
            singleClass: PropTypes.oneOfType([
                PropTypes.func,
                PropTypes.object
            ]),
            student: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
        }).isRequired
    };

    constructor(props) {
        super(props);

        const { match } = props;
        this.defaultPath = match.url;
        if (this.defaultPath.charAt(this.defaultPath.length - 1) === '/') {
            this.defaultPath = this.defaultPath.substring(
                0,
                this.defaultPath.length - 1
            );
        }
        this.yearGroupPath = `${this.defaultPath}/${YEAR_GROUP_PATH}/:yearGroupId`;
        this.yearGroupTeacherPath = `${this.defaultPath}/${YEAR_GROUP_PATH}/:yearGroupId/${TEACHER_PATH}/:teacherId`;
        this.teacherPath = `${this.defaultPath}/${TEACHER_PATH}/:teacherId`;
        this.classPath = `${this.defaultPath}/${CLASS_PATH}/:classId`;
        this.groupPath = `${this.classPath}/${GROUP_PATH}/:groupId`;
        this.studentPath = `${this.classPath}/${STUDENT_PATH}/:studentId`;
    }

    /** Routes shared by both admins & teachers */
    getSharedRoutes() {
        const { singleClass, student } = this.props.components;
        return [
            <Route
                key={0}
                exact
                path={this.classPath}
                component={singleClass}
            />,
            <Route
                key={1}
                exact
                path={this.groupPath}
                component={singleClass}
            />,
            <Route key={2} exact path={this.studentPath} component={student} />,
            <Redirect key={3} from="*" to={this.defaultPath} />
        ];
    }

    renderRoutes = () => {
        const { children, isAdmin } = this.props;

        return (
            <div>
                {children}
                {isAdmin === true
                    ? this.renderAdminRoutes()
                    : this.renderTeacherRoutes()}
            </div>
        );
    };

    renderAdminRoutes = () => {
        const { allClasses } = this.props.components;
        return (
            <Switch>
                <Route
                    exact
                    strict
                    path={this.defaultPath}
                    component={allClasses}
                />
                <Route exact path={this.yearGroupPath} component={allClasses} />
                <Route
                    exact
                    path={this.yearGroupTeacherPath}
                    component={allClasses}
                />
                <Route exact path={this.teacherPath} component={allClasses} />
                {this.getSharedRoutes()}
            </Switch>
        );
    };

    renderTeacherRoutes = () => {
        const { allClasses } = this.props.components;

        return (
            <Switch>
                <Route
                    exact
                    strict
                    path={this.defaultPath}
                    component={allClasses}
                />
                {this.getSharedRoutes()}
            </Switch>
        );
    };

    render() {
        const { isAdmin } = this.props;
        // isAdmin will equal null until the backend returns a value for the is admin request
        if (isAdmin === null) {
            return null;
        }
        return this.renderRoutes();
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers
 */
function mapStateToProps(state) {
    return {
        isAdmin: state.isAdmin
    };
}

export default withRouter(connect(mapStateToProps)(ReportRoutes));



// WEBPACK FOOTER //
// ./containers/report-routes/report-routes.js